import React, { useEffect } from 'react';
import { MemoryRouter as Router, Switch, Route } from 'react-router-dom';
// import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import RootContainer from './container/root';
import RegisterContainer from './container/register';
import LoginContainer from './container/login';
import AccessKeyContainer from './container/accesskey';
import RegisterPricingContainer from './container/registerpricing';
import RegisterPaywallContainer from './container/registerpaywall';
import ContentContainer from './container/content';
import DashboardContainer from './container/dashboard';
import PricingContainer from './container/pricing';
import SettingsContainer from './container/settings';
// import CobrandingContainer from './container/cobranding';
import PrivateRoute from './components/utils';
import CategoryContainer from './container/category';
import { editWPArticles } from './actions';

const getWordpressArticles = async (name) => {
  return new Promise((resolve, reject) => {
    // eslint-disable-next-line no-undef
    jQuery(document).ready(async ($) => {
      await $.ajax({
        // eslint-disable-next-line no-undef
        url: ajaxurl,
        data: {
          action: 'process_post_request', // This is our PHP function below
          post_type: 'POST',
          requestFor: 'retrieve_posts',
          author_name: name
        },
        async success(data) {
          resolve(JSON.parse(data));
        },
        error(errorThrown) {
          console.log(errorThrown);
          reject(errorThrown);
        }
      });
    });
  });
};

const App = () => {
  const publisherId = useSelector((state) => state.user.publisher?.id);
  const userId = useSelector((state) => state.user.user?.id);
  const userName = useSelector((state) => state.user.user?.name);
  const dispatch = useDispatch();

  useEffect(() => {
    if (publisherId && userId) {
      getWordpressArticles(userName).then((data) => {
        console.log(data);
        dispatch(editWPArticles(data));
      });
    }
  }, [publisherId, userId]);

  return (
    <Router basename="/wp-admin/admin.php?page=fcpay-settings">
      <Switch>
        <PrivateRoute path="/content" exact>
          <ContentContainer />
        </PrivateRoute>
        <PrivateRoute path="/dashboard" exact>
          <DashboardContainer />
        </PrivateRoute>
        <PrivateRoute path="/pricing" exact>
          <PricingContainer />
        </PrivateRoute>
        <PrivateRoute path="/settings" exact>
          <SettingsContainer />
        </PrivateRoute>
        <PrivateRoute path="/category" exact>
          <CategoryContainer />
        </PrivateRoute>
        {/* <PrivateRoute path="/cobranding" exact>
          <CobrandingContainer />
        </PrivateRoute> */}
        <Route path="/register" exact>
          <RegisterContainer />
        </Route>
        <Route path="/login" exact>
          <LoginContainer />
        </Route>
        <Route path="/accesskey" exact>
          <AccessKeyContainer />
        </Route>
        <Route path="/registerpricing" exact>
          <RegisterPricingContainer />
        </Route>
        <Route path="/registerpaywall" exact>
          <RegisterPaywallContainer />
        </Route>
        <Route path="/" exact>
          <RootContainer />
        </Route>
      </Switch>
    </Router>
  );
};

export default App;
